import React, { useEffect } from 'react';
import service from '../services/StatusEnquiryApiService';
import Loading from '../components/Loading';
import { useHistory } from 'react-router-dom';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';
 
let propsUEN = '', propsIDNum = '',propsSId = '',propsRefNo ='';

const StatusDetails = (props) => {
    const history = useHistory();
 
    useEffect(() => {
        console.log('@StatusDetails useEffect');
        window.scrollTo(0, 0);
        getPropsData();
    }, []);

    const getPropsData = () => {   //parse form preview or resume application 
 
        if(props.location.state !== undefined) { //not first time
         
            propsUEN = props.location.state.uen? props.location.state.uen:'';
            propsIDNum = props.location.state.idNum? props.location.state.idNum:'';
            propsSId = props.location.state.sid? props.location.state.sid:'';
            propsRefNo = props.location.state.refNo? props.location.state.refNo:'';
            
            if(props.location.state.from === config.route.Preview) {
                getStatus(propsSId,propsRefNo);
            }
            else if(props.location.state.from === config.route.ResumeApplication) {
                getStatusEnquiry(propsSId,propsRefNo);
            }
            else if(props.location.state.from === config.route.UploadDetails) {
                getStatusEnquiry(propsSId,propsRefNo);
            }
        }
        else {
            //redirect to error screen
            // getStatusEnquiry(propsSId,propsRefNo);
             props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        }
    }

    const getStatus = (sid,rno) => {
        service.getStatus(sid,rno).then( res => {
            let resData = res.data.model.fields.request;
            goNext(resData);
        })
        .catch( err => {
            console.log('getStatus err: ',err);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

    const getStatusEnquiry = (sid,rno) => {
        storage.setStateId(sid);
        service.getStatusEnquiry(sid,rno).then( res => {
            let resData = res.data.model.fields.request;
            goNext(resData)
        })
        .catch( err => {
            console.log('getStatus err: ',err);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

    const goNext = (resData) => {
        let appStatus = resData.StatusDtls.ApplicationProgress;
        let status = appStatus.toLowerCase();
        const pType = resData.StatusDtls.ProductType.toUpperCase();
        if(status ===  config.StatusDtls.ApplicationPending || status === config.StatusDtls.ApplicationComplete) {
            //route to submission   
       
            if(pType === config.bizFinancing.BTL){
                history.push(config.route.SubmitDetails,{from: config.route.StatusDetails,response:resData}); 
            }
            else {//Hybrid or AIP
                history.push(config.route.HSubmitDetails,{from: config.route.StatusDetails,response:resData}); 
            }
        }
        else {
            checkStatusCodeFromWAA(appStatus,resData);
        }
    }

    const checkStatusCodeFromWAA = (appStatusCode,resData) => {
        let code = appStatusCode;
        const pType = resData.StatusDtls.ProductType.toUpperCase();
        const isOTP = resData.StatusDtls.isExistingOTPAvailable?resData.StatusDtls.isExistingOTPAvailable:'';
         //LP - Loan Processing   
        if(pType === config.bizFinancing.BTL) { //existing BTL, Non Hybrid
            if(code === config.StatusDtls.LP ) {  
                history.push(config.route.SubmitDetails,{from: config.route.StatusDetails,response:resData});
            }
            //LI - LO Accept in progress, LE - LO Expired   
            else if(code === config.StatusDtls.LI || code === config.StatusDtls.LE || code === config.StatusDtls.UM) {
                history.push(config.route.ReviewOffer,{from: config.route.StatusDetails,response:resData}); 
            }
            //LA - Loan Offer Accepted, DI - Disbursement in progress,DC - Disbursement completed, DE  - Disbursement error, RJ - Rejected 
            else if(code === config.StatusDtls.LA || code === config.StatusDtls.DI 
                || code === config.StatusDtls.DC  || code === config.StatusDtls.DE 
                || code === config.StatusDtls.RJ || code === config.StatusDtls.AB) {
                history.push(config.route.Disbursement,{from: config.route.StatusDetails,response:resData}); 
            }
        }
        else if(pType === config.bizFinancing.PBF){ //HYBRID
            if(code === config.StatusDtls.HLP) {  //Loan Processing
                history.push(config.route.HSubmitDetails,{from: config.route.StatusDetails,response:resData}); 
            }
            //LA - Loan Accept
            else if(code === config.StatusDtls.HLA) {
                history.push(config.route.HStatusInfoDetails,{from: config.route.StatusDetails,response:resData}); 
            }
            else if(code === config.StatusDtls.HRJ || code === config.StatusDtls.HAB || code === config.StatusDtls.HUM) {
                history.push(config.route.HStatusReject,{from: config.route.StatusDetails,response:resData}); 
            }
            else {
                props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
            }
        }
        else if(pType === config.bizFinancing.AIP){ //AIP
            if(isOTP==='N') { //PURE AIP
                if(code === config.StatusDtls.APN || code === config.StatusDtls.LP || code === config.StatusDtls.AHB || code === config.StatusDtls.HLP) { //temp PQR/PQR creation or Loan Processing
                    history.push(config.route.HSubmitDetails,{from: config.route.StatusDetails,response:resData}); 
                }
                else if( code === config.StatusDtls.LAP) { //Final Approved   
                    history.push(config.route.AIPStatusInfoDetails,{from: config.route.StatusDetails,response:resData}); 
                }
                else if(code === config.StatusDtls.AAP || code === config.StatusDtls.ALP) { // Temp Approved 
                    history.push(config.route.AIPStatusApproved,{from: config.route.StatusDetails,response:resData});
                }
                else if(code === config.StatusDtls.AUM || code === config.StatusDtls.AEX) {
                    history.push(config.route.AIPStatusReject,{from: config.route.StatusDetails,response:resData});
                }
                else if(code === config.StatusDtls.HLA) { // after AHB - follow the Hybrid codes
                    history.push(config.route.HStatusInfoDetails,{from: config.route.StatusDetails,response:resData}); 
                }
                else if(code === config.StatusDtls.ARJ || code === config.StatusDtls.HRJ || code === config.StatusDtls.HAB || code === config.StatusDtls.HUM) {
                    history.push(config.route.HStatusReject,{from: config.route.StatusDetails,response:resData}); 
                }
                else {
                    props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
                }
            }
            else { //HYBRID
                if(code === config.StatusDtls.HLP || code === config.StatusDtls.AHB) {  //Loan Processing
                    history.push(config.route.HSubmitDetails,{from: config.route.StatusDetails,response:resData}); 
                }
                //LA - Loan Accept
                else if(code === config.StatusDtls.HLA) {
                    history.push(config.route.HStatusInfoDetails,{from: config.route.StatusDetails,response:resData}); 
                }
                else if(code === config.StatusDtls.ARJ || code === config.StatusDtls.HRJ || code === config.StatusDtls.HAB || code === config.StatusDtls.HUM) {
                    history.push(config.route.HStatusReject,{from: config.route.StatusDetails,response:resData}); 
                }
                else {
                    props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
                }
            }
        }
    }

    return (
        <Loading />
    )
}

export default StatusDetails;